import * as actions from './outcomes-actions';
import * as selectors from './outcomes-selectors';
import {reducer} from './outcomes-reducer';

export const Outcomes = {reducer, ...actions, ...selectors} as const;
export type {OutcomesState} from './outcomes-reducer';
